import { Dispatch } from "redux";
import { setFormValues } from "../CreateEmployeeModalSlice";
import { EstablishmentInterface } from "../../../common/interfaces/EstablishmentInterface";

export const setEstablishmentFormValues = (
    dispatch: Dispatch,
    establishment?: EstablishmentInterface | null,
): void => {
    if (!establishment) {
        return;
    }

    dispatch(
        setFormValues({
            establishment: {
                selectedId: establishment.id,
                selectedValue: establishment.name,
            },
        }),
    );
};
